module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_kawaduzakura_aqua-a671e28448efd1d6359c564693186278.jpg";